import React from "react";
import styles from "./PrivacyPolicy.module.css";

export default function CancellationPolicy() {
    return (
        <div className={styles.privacyContainer}>
            <h1 style={{ textAlign: "center" }}>Cancellation & Refund Policy</h1>

            <section>
                <h4>1. Booking Modification (Partial Day Cancellation)</h4>
                <p>
                    Guests can modify their booking dates (Shortening the stay).
                </p>
                <ul style={{ lineHeight: "1.8", marginBottom: "1.5rem" }}>
                    <li><strong>Eligibility:</strong> Available only for bookings with a duration of <strong>more than 1 day</strong>.</li>
                    <li><strong>How it works:</strong> You can change your Check-in and Check-out dates. Refund or additional charges will be calculated based on the new dates and the cancellation window.</li>
                    <li><strong>Restrictions:</strong>
                        <ul style={{ listStyleType: "circle", marginLeft: "20px" }}>
                            <li>Each <strong>booking</strong> can be modified <strong>only once</strong>.</li>
                            <li>If you choose to modify dates (Partial Day Cancellation), you will be <strong>unable</strong> to perform a Partial Room Cancellation later for the same booking. However, you can still proceed with a Full Cancellation of the entire booking.</li>
                        </ul>
                    </li>
                </ul>
            </section>

            <section>
                <h4>2. Partial Room Cancellation</h4>
                <p>
                    Guests with multiple rooms in a single booking can cancel specific rooms while keeping others active.
                </p>
                <ul style={{ lineHeight: "1.8", marginBottom: "1.5rem" }}>
                    <li><strong>Eligibility:</strong> Available only for bookings containing <strong>more than 1 room</strong>.</li>
                    <li><strong>How it works:</strong> You can select individual rooms to remove from your booking. The refund will be calculated for those specific rooms based on the standard cancellation deductions.</li>
                    <li><strong>Restrictions:</strong>
                        <ul style={{ listStyleType: "circle", marginLeft: "20px" }}>
                            <li>Once you initiate a Partial Room Cancellation, you are <strong>locked</strong> into this mode. You cannot switch to Booking Modification (Partial Day Cancellation) for the remaining rooms.If you wish to cancel all remaining rooms you can cancel it one by one using partial room cancellation feature.</li>
                            
                        </ul>
                    </li>
                </ul>
            </section>

            <section>
                <h4>3. Full Cancellation</h4>
                <p>
                    Guests can cancel their entire booking (all rooms) at once.
                </p>
                <ul style={{ lineHeight: "1.8", marginBottom: "1.5rem" }}>
                    <li><strong>Eligibility:</strong> Available for all active bookings, provided the cancellation is made before the "No Cancellation" window (less than 2 days before check-in).</li>
                    <li><strong>How it works:</strong> All rooms in the booking are cancelled. The refund is calculated based on the total booking value and the applicable deduction percentage.</li>
                </ul>
            </section>

            <section>
                <h4>4. Cancellation Charges & Deduction Policy</h4>
                <table className="table table-bordered" style={{ width: '100%', marginTop: '15px', borderCollapse: 'collapse', marginBottom: '1.5rem' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f8f9fa' }}>
                            <th style={{ padding: '10px', border: '1px solid #dee2e6' }}>Cancellation Window (Before Check-in)</th>
                            <th style={{ padding: '10px', border: '1px solid #dee2e6' }}>Deduction</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ padding: '10px', border: '1px solid #dee2e6' }}>15 or more days</td>
                            <td style={{ padding: '10px', border: '1px solid #dee2e6' }}>20% of Total Amount</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', border: '1px solid #dee2e6' }}>7 to 14 days</td>
                            <td style={{ padding: '10px', border: '1px solid #dee2e6' }}>30% of Total Amount</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', border: '1px solid #dee2e6' }}>2 to 6 days</td>
                            <td style={{ padding: '10px', border: '1px solid #dee2e6' }}>50% of Total Amount</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', border: '1px solid #dee2e6', color: '#dc3545', fontWeight: 'bold' }}>Less than 2 days</td>
                            <td style={{ padding: '10px', border: '1px solid #dee2e6', color: '#dc3545', fontWeight: 'bold' }}>No Refund (100% Deduction)</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <section>
                <h4>5. Refund Process</h4>
                <p>
                    Refunds (if applicable) will be processed to the original payment method used during booking. The refund timeline is typically <strong>7–10 working days</strong>, depending on the bank or payment gateway.
                </p>
                <p>
                    <strong>Note:</strong> No refund will be issued for no-shows or early check-outs (unless processed as a valid Booking Modification).
                </p>
            </section>

            <section style={{ marginTop: '2rem', borderTop: '1px solid #eee', paddingTop: '1rem' }}>
                <h4>Contact Information</h4>
                <p>
                    For any queries regarding cancellations or refunds, please contact us:<br />
                    <strong>Jharkhand Tourism Development Corporation Ltd. (JTDCL)</strong><br />
                    Email: jtdcltd@gmail.com <br />
                    Phone: +91 9102403884
                </p>
            </section>
        </div>
    );
}
